const styles = theme => ({
  root: {
    gridColumnStart: 2,
    padding: theme.spacing(5, 0),
  },
  alignHeading:{
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between',
    margin:'2rem 0px', 
    // textAlign:'right',
      '& a':{
      backgroundColor:'#e60000',
      border:'1px solid #e60000',
      color:'#fff',
      // width: '100%',
      padding: '12px',
      'box-sizing': 'border-box',
      textAlign: 'center',
      display:'inline-block',
      fontSize: '20px',
      fontFamily: "VodafoneRg-Regular",
      borderRadius:'5px',
      transition:'all 300ms ease',
      '&:hover':{
        background:'transparent',
        border:'1px solid #e60000',
        color:'#333'
      }
    }
  },
  
  IdeaGrid: {
    display: "grid",
    marginTop: "32px",
    marginBottom: "60px",
    gridTemplateColumns: "repeat(2,minmax(128px,1fr))",
    gridGap: '8px',
    alignItems: "center",
    justifyItems: "center",
    '@media (min-width:480px)': { 
        gridTemplateColumns: "repeat(3,minmax(144px,1fr))",
    },
    '@media (min-width:1024px)': { 
        gridTemplateColumns: "repeat(4,minmax(238px,1fr))",
    },
  },

})

export default styles
